"use client";
import { useAuth } from "@/contexts/authContext";
import { usePathname, useRouter } from "next/navigation";
import { useEffect } from "react";

export default function ProfileCompletionWatcher() {
  const { user, isInitialized } = useAuth();
  const router = useRouter();
  const pathname = usePathname();

  const isExcludedPage =
    pathname?.startsWith("/signup") ||
    pathname?.startsWith("/complete-profile") ||
    pathname?.startsWith("/after-login/profile-completion");

  const needsProfileCompletion =
    isInitialized && user && !user.account_type && !isExcludedPage;

  useEffect(() => {
    if (needsProfileCompletion) {
      router.push("/complete-profile");
    }
  }, [needsProfileCompletion, router]);

  return null;
}
